import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UserNameLink from 'flow-doctor-lib/components/common/UserNameLink';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const BulkEnrollFiltersAnalysisReason = ({
  diagnosisReason,
  selectedEnrollment
}) => {
  const enrolledByUserId = diagnosisReason.userId;
  if (!enrolledByUserId) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.BULK_ENROLL_FILTER.withoutUser_jsx",
      elements: {
        ObjectTypeLabel
      },
      options: {
        objectTypeLabel: {
          lowerCase: true,
          portalId: selectedEnrollment.portalId,
          plural: true,
          objectTypeId: selectedEnrollment.objectTypeId
        }
      }
    });
  }
  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.description.BULK_ENROLL_FILTER.withUser_jsx',
      elements: {
        UserNameLink,
        ObjectTypeLabel
      },
      options: {
        objectTypeLabel: {
          lowerCase: true,
          portalId: selectedEnrollment.portalId,
          plural: false,
          objectTypeId: selectedEnrollment.objectTypeId
        },
        userNameLink: {
          portalId: selectedEnrollment.portalId,
          userId: enrolledByUserId
        }
      }
    })
  });
};
export default BulkEnrollFiltersAnalysisReason;